<template>
  <div class="card shadow">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col-6">
          <h3 class="mb-3">
            {{ tableTitle }}
          </h3>
        </div>
        <div class="col-6 text-right">
          <slot name="headerButtons"> </slot>
        </div>
      </div>
    </div>

    <slot name="formDrawer"></slot>

    <div class="d-flex justify-content-start" :style="{ marginTop: '-25px' }">
      <div class="px-4">
        <small>
          <vuetable-pagination-info
            ref="paginationInfo"
            info-class="pagination-info"
            info-template="{total} Entries"
          ></vuetable-pagination-info>
        </small>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <a-spin :spinning="loading">
        <vuetable
          ref="vuetable"
          :fields="fields"
          :sort-order="sortOrder"
          :sort-params="sortParams"
          :multi-sort="multiSort"
          :multi-sort-key="multiSortKey"
          no-data-template="Empty"
          :css="css.table"
          :show-sort-icons="true"
          :per-page="perPageDisplay"
          pagination-path=""
          data-path="data"
          :api-url="apiUrl"
          :append-params="appendedParams"
          :http-options="httpOptions"
          @vuetable:checkbox-toggled-all="toggleCheckbox"
          @vuetable:checkbox-toggled="toggleCheckbox"
          @vuetable:pagination-data="onPaginationData"
          @vuetable:loading="loading = true"
          @vuetable:load-success="eventLoadSuccess"
          @vuetable:load-error="onLoadError"
        >
          <template slot="custom-slot" slot-scope="props">
            <slot name="customComponent" :tableProps="props"></slot>
          </template>

          <template slot="actions" slot-scope="props">
            <center>
              <div class="table-button-container">
                <slot name="tableButtons" :tableProps="props"></slot>
              </div>
            </center>
          </template>
        </vuetable>
      </a-spin>
    </div>

    <div class="card-footer d-flex">
      <div class="mr-auto p-2 bd-highlight">
        <slot v-if="displayfooterNotes" name="footerNotes"></slot>
      </div>

      <div class="pagination ui basic segment grid">
        <b-col v-show="showPerPageSelector" fluid="sm">
          <b-form-select
            v-model="selectedPerPage"
            :options="displayPerPage(maxPageDisplay)"
          ></b-form-select>
        </b-col>
        <vuetable-pagination
          ref="pagination"
          @vuetable-pagination:change-page="onChangePage"
          :css="css.pagination"
        >
        </vuetable-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo';
import secureStorage from '../../controllers/secureStorage';

export default {
  name: 'PageTable',
  props: {
    tableTitle: String,
    tableFields: Array,
    apiUrl: String,
    perPage: {
      type: Number,
      default: 10
    },
    maxPageDisplay: {
      type: Number,
      default: 100
    },
    showPerPageSelector: {
      type: Boolean,
      default: true
    },
    appendedParams: {
      type: Object,
      default: undefined
    },
    displayfooterNotes: {
      type: Boolean,
      default: false
    },
    sortOrder: {
      type: Array,
      default: () => [
        {
          field: 'id',
          direction: 'asc'
        }
      ]
    },
    httpOptions: {
      type: Object,
      default: () => ({
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem('bxiClpAccessToken')
        }
      })
    },
    sortParams: {
      type: Function,
      default: null
    },
    multiSort: {
      type: Boolean,
      default: false
    },
    multiSortKey: {
      type: String,
      default: null
    }
  },
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data() {
    return {
      response: null,
      selectedPerPage: this.perPage,
      loading: false,
      fields: this.tableFields,
      // httpOptions: {
      //   headers: {
      //     Authorization: 'Bearer ' + secureStorage.getItem('bxiClpAccessToken')
      //   }
      // },
      css: {
        table: {
          tableClass:
            'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading',
          ascendingIcon: 'fa fa-chevron-up',
          descendingIcon: 'fa fa-chevron-down',
          ascendingClass: 'sorted-asc',
          descendingClass: 'sorted-desc',
          sortableIcon: 'fa fa-sort',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'fa fa-bars text-secondary'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      }
    };
  },
  methods: {
    eventLoadSuccess(response) {
      this.loading = false;
      this.response = response.data;
      this.$emit('doneLoading', this.response);
    },
    toggleCheckbox() {
      const vuetable = this.$refs.vuetable;
      const selected = vuetable.selectedTo;
      const tableData = vuetable.tableData;
      let checked = [];

      for (const id of selected) {
        for (const data of tableData) {
          if (id == data.id) {
            checked.push(data);
          }
        }
      }
      this.$emit('toggleCheckbox', checked);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onLoadError(error) {
      let message = error?.response?.data?.message;
      console.log(error);
      this.$message.error(message ? message : 'Unable to fetch data.', 10);
      this.loading = false;
    },
    refreshTable() {
      if (this.$refs.vuetable) {
        this.$refs.vuetable.refresh();
        console.log('refreshTable');
      }
    },
    clearTableData() {
      if (this.$refs.vuetable) {
        this.$refs.vuetable.resetData();
        console.log('reset table data');
      }
    },
    displayPerPage(limit = 100) {
      const opts = [10, 20, 50, 100].filter((n) => n <= limit);
      return opts.map((n) => ({ value: n, text: n }));
    }
  },
  computed: {
    perPageDisplay() {
      return this.selectedPerPage;
    },
    cardInventoryModule() {
      return this.$store.state.currentModule == 'Card Inventory';
    }
  },
  watch: {
    perPage(newVal) {
      this.selectedPerPage = newVal;
    },
    selectedPerPage(newVal, oldVal) {
      if (newVal !== oldVal && this.$refs.vuetable) {
        // Re-fetch data using the updated per-page value
        this.$refs.vuetable.changePage(1);
      }
    }
  },
  mounted() {
    this.$root.$on('refreshTable', () => {
      return this.refreshTable();
    });
    this.$root.$on('clearTableData', () => {
      return this.clearTableData();
    });
    console.log('Table mounted.');
  },
  created() {
    if (secureStorage.getItem('source')) {
      this.appendedParams['source'] = secureStorage.getItem('source');
    }
  },
  beforeUpdate() {
    if (secureStorage.getItem('source')) {
      this.appendedParams['source'] = secureStorage.getItem('source');
    }
  }
};
</script>
<style scoped></style>
